import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "panel"]

  connect() {
    this.open = false
    this.sync()
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    this.open = !this.open
    this.sync()
  }

  hide() {
    if (!this.open) return

    this.open = false
    this.sync()
  }

  outside(event) {
    if (!this.open) return
    if (this.element.contains(event.target)) return

    this.hide()
  }

  sync() {
    this.panelTarget.classList.toggle("hidden", !this.open)
    this.buttonTarget.setAttribute("aria-expanded", String(this.open))
  }
}
